import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propArrayShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import Hover from '../../../../../../Ui/System/Hover';
import Tooltip from '../../../../../../Ui/Tooltip/Tooltip';
const SharedMemberTooltip = (props) => {
    const { className, members } = props;
    const numberComponent = (_jsx("div", Object.assign({ className: clsx('proffit_search_folder_share_member_count', className) }, { children: members.length })));
    if (!members.length) {
        return numberComponent;
    }
    return (_jsx(Tooltip, Object.assign({ html: _jsx("ul", { children: members.map((v) => (_jsx("li", Object.assign({ className: 'text-liststyle is-dot' }, { children: v.lastName && v.firstName
                    ? `${v.lastName} ${v.firstName}`
                    : v.email }), v.id))) }), position: 'left' }, { children: _jsx(Hover, { children: numberComponent }) })));
};
SharedMemberTooltip.propTypes = {
    className: propStr(),
    members: propArrayShape().isRequired,
};
SharedMemberTooltip.defaultProps = {
    className: '',
};
export default SharedMemberTooltip;
